export const BEAMER_SELECTOR_ID = 'beamerTrigger'
export const BEAMER_SCRIPT_ID = 'beamerScript'
// Intercom's "Website element click" trigger targets this id to start Oscar's feature-request flow.
export const SUGGEST_FEATURE_SELECTOR_ID = 'suggestFeatureTrigger'
